function isSummertime(date) {
	return date.getTimezoneOffset() === -120
}

export function convertDateStr(inputDateStr) {
	if (inputDateStr === '') {
		return null;
	}
	return dateConvertToIso(new Date(inputDateStr))
}

export function convertDateStrEncoded(inputDateStr) {
	if (inputDateStr === '') {
		return null;
	}
	return inputDateStr;
	// return (dateConvertToIso(new Date(inputDateStr)) || "").replace("+","  %2B")
}

export function dateConvertToIso(date) {
	let dateString;
	let day = '';
	let month = '';
	if (date.getDate() < 10) {
		day = '0' + date.getDate().toString();
	} else {
		day = date.getDate().toString();
	}
	if (date.getMonth() < 9) {
		month = '0' + (date.getMonth() + 1).toString();
	} else {
		month = (date.getMonth() + 1).toString();
	}
	if (isSummertime(date)) {
		dateString = date.getFullYear() + '-' + month + '-' + day + 'T00:00:00+02:00';
	} else {
		dateString = date.getFullYear() + '-' + month + '-' + day + 'T00:00:00+01:00';
	}
	return dateString;
}

export function getNorwayMonth(monthNumber) {
	switch (monthNumber) {
		case 0:
			return 'Januar';

		case 1:
			return 'Februar';

		case 2:
			return 'Mars';

		case 3:
			return 'April';

		case 4:
			return 'Mai';

		case 5:
			return 'Juni';

		case 6:
			return 'Juli';

		case 7:
			return 'August';

		case 8:
			return 'September';

		case 9:
			return 'Oktober';

		case 10:
			return 'November';

		case 11:
			return 'Desember';

		default:
			break;
	}
}